import { render, staticRenderFns } from "./voc.vue?vue&type=template&id=690cf5a8&scoped=true&"
import script from "./voc.vue?vue&type=script&lang=js&"
export * from "./voc.vue?vue&type=script&lang=js&"
import style0 from "./voc.vue?vue&type=style&index=0&id=690cf5a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690cf5a8",
  null
  
)

export default component.exports